import { graphql } from 'react-relay';

export const createPaymentCard = graphql`
  mutation createPaymentCardMutation($paymentCardInfoInput: PaymentCardInfoInput!) {
    createPaymentCard(paymentCardInfoInput: $paymentCardInfoInput) {
      result
      errors {
        code
        message
      }
    }
  }
`;
